import { fetcher } from 'utils/axios';

/** תא מונה בודד: סך-הכול ולא-נקראו */
export interface ViewCountCell {
  total: number;
  unread: number;
}

export type ChatScope = 'mine' | 'team' | 'all';

/** מוני system: scope → (status 1..6) → תא */
export type SystemCounts = Partial<Record<ChatScope, Record<string, ViewCountCell>>>;

export interface UnreadCountsCustomView {
  viewId: string;
  filters: any[];
  filtersLogic?: 'and' | 'or';
}

export interface UnreadCountsRequest {
  currentUserUdid: string;
  scopes: ChatScope[];
  customViews: UnreadCountsCustomView[];
  correlationId: string;
}

export interface UnreadCountsResponse {
  system: SystemCounts;
  /** מונה תצוגת «בוטים» — שיחות שמוחזקות כרגע אצל בוט (מוחרגות מהמונים הרגילים) */
  bots?: ViewCountCell;
  custom: Record<string, ViewCountCell>;
  meta?: {
    correlationId?: string;
    computedAtIso?: string;
    tookMs?: number;
    customViewsCounted?: number;
    partial?: boolean;
  };
}

const DEBUG = Boolean((import.meta as any).env?.VITE_DEBUG_UNREAD_COUNTS);

/**
 * מושך את מוני התצוגות מ-Node (`/api/services/getUnreadCounts`).
 * מחזיר null בשגיאה — הקורא משאיר את הערכים הקודמים (stale-but-visible).
 */
export async function fetchUnreadCounts(req: UnreadCountsRequest): Promise<UnreadCountsResponse | null> {
  const t0 = typeof performance !== 'undefined' ? performance.now() : 0;
  try {
    if (DEBUG) {
      console.debug(
        `[unread-counts] request · scopes=[${req.scopes.join(',')}] · customViews=${req.customViews.length} · cid=${req.correlationId}`,
      );
    }

    const data = (await fetcher(
      'post',
      ['/api/services/getUnreadCounts', { data: req }],
      'servernode',
    )) as UnreadCountsResponse | null;

    const roundTripMs = t0 ? Math.round(performance.now() - t0) : -1;
    const partial = data?.meta?.partial;
    const line = `[unread-counts] response · tookMs=${data?.meta?.tookMs ?? '?'} · roundTripMs=${roundTripMs} · partial=${partial} · cid=${req.correlationId}`;
    if (partial) {
      console.warn(line);
    } else if (DEBUG) {
      console.debug(line);
    }

    return data;
  } catch (error) {
    console.error(`[unread-counts] request failed · cid=${req.correlationId}`, error);
    return null;
  }
}
